import {default as globals} from '../base/_globals.js';

const desktopDelay = 300;
const mainMenu = document.getElementById('main_menu');
const subMenuVisibleClass = 'sub-menu-display';
let listItems = null;
let timer = null;

if ( mainMenu ) {
	listItems = mainMenu.querySelectorAll('#main_menu > li');
}


/**
 *
 *
 *
 */
const init = function() {

	setupMobileSubmenu();
	setupDesktopSubmenus();

};


/**
 *
 *
 *
 */
const setupDesktopSubmenus = function() {

	if ( listItems ) {

		Array.prototype.forEach.call(listItems, function( el ) {

			const a = el.querySelector('a');
			const hasChildren = el.classList.contains('menu-item-has-children');

			el.addEventListener("mouseover", () => {
				hideOtherDesktopSubmenus();
				if (hasChildren) {
					showDesktopSubmenu(el);
				}
			});

			if ( hasChildren ) {

				el.addEventListener("mouseout", () => {
					timer = setTimeout( () => {
						hideDesktopSubmenu(el);
					}, desktopDelay);
				});

				a.addEventListener("focus", () => {
					showDesktopSubmenu(el);
				});

				el.addEventListener('focusout', (e) => {

					if ( !el.contains(e.relatedTarget) ) {
						hideDesktopSubmenu(el);
					}

				});

			}

		});

	}

};


/**
 *
 *
 *
 */
const setupMobileSubmenu = function() {

	const allItemsWithSubmenus = mainMenu.querySelectorAll( '#main_menu .menu-item-has-children' );

	Array.prototype.forEach.call( allItemsWithSubmenus, function( el ) {

		const button = document.createElement( 'button' );
		const label = document.createElement( 'span' );
		const submenu = el.querySelector( '.sub-menu' );
		const parent = submenu.parentNode;

		label.setAttribute( 'class', 'screen-reader-text' );
		label.innerHTML = 'Show Submenu';

		button.setAttribute( 'class', 'sub-menu-button' );
		button.setAttribute( 'aria-expanded', 'false' );
		button.setAttribute( 'aria-label', 'Menu' );
		button.insertAdjacentElement( 'beforeend', label );

		submenu.insertAdjacentElement( 'beforebegin', button );

		button.addEventListener( 'click', () => {
			const expanded = button.getAttribute('aria-expanded') === 'true' || false;
			parent.classList.toggle('is-expanded');
			button.setAttribute( 'aria-expanded', !expanded );
		} );

	});

}



/**
 *
 *
 *
 */
const showDesktopSubmenu = function(el) {

	if ( window.innerWidth >= globals.breakpoint ) {
		el.classList.add(subMenuVisibleClass);
		el.setAttribute('aria-expanded', 'true');
	} else {
		el.classList.remove(subMenuVisibleClass);
		el.removeAttribute('aria-expanded');
	}
};


/**
 *
 *
 *
 */
const hideDesktopSubmenu = function(el) {
	if ( window.innerWidth >= globals.breakpoint ) {
		el.classList.remove(subMenuVisibleClass);
		el.setAttribute('aria-expanded', 'false');
	} else {
		el.classList.remove(subMenuVisibleClass);
		el.removeAttribute('aria-expanded');
	}
}


/**
 *
 *
 *
 */
const hideOtherDesktopSubmenus = function(currentEl) {

	clearTimeout(timer);

	Array.prototype.forEach.call(listItems, function(el) {
		if ( el !== currentEl ) {
			hideDesktopSubmenu(el);
		}
	});

}


const api = {
	init: init
};

export default api;